import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          {/* <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/about.jpg" className="img-responsive" alt="" />{" "}
          </div> */}
          <div className="col-xs-12 col-md-12">
            <div className="about-text">
              <h2>{props.data ? props.data.title : "Loading..."}</h2>
              <p>{props.data ? props.data.subtitle : "loading..."}</p>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
